/**
 * @Author: v_jppjpeng
 * @Date: 2023-3-14 10:26:48
 * @Explain: 业务管理（项目、绑定角色、权限）
 */
import http from '../http';

const MODEL = '/game';

export default {
  // 项目列表
  getList(data: Record<any, any>) {
    return http.post(
      data.state === 1
        ? `${MODEL}/my-available-game-list`
        : `${MODEL}/my-pending-game-list`,
      data,
    );
  },
  // 获取demo项目
  getDemoProject(data: Record<any, any>) {
    return http.post(`${MODEL}/get-demo-game`, data);
  },
  // 创建项目
  postGameCreate(data: Record<any, any>) {
    return http.post(`${MODEL}/create`, data);
  },
  // 搜索project详情
  postSearchProjectId(data: Record<any, any>) {
    return http.post(`${MODEL}/get-game-state`, data);
  },
  // 查询系统可申请权限的角色列表
  getMyAccountRoles(data: Record<any, any>) {
    return http.post(`account/get-my-account-roles`, data);
  },
};
